import React from 'react';
import { Link } from 'react-router-dom';

function Privacy() {
    return (
        <div className="privacy-page">
            {/* Hero Section */}
            <section className="privacy-hero py-5 bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <h1 className="display-4 fw-bold text-dark mb-4">
                                <i className="bi bi-shield-check text-warning me-3"></i>
                                Privacy Policy
                            </h1>
                            <p className="lead text-muted mb-4">
                                La tua privacy è importante per noi. Questa pagina descrive come gestiamo e proteggiamo i tuoi dati.
                            </p>
                            <p className="text-muted small">
                                Ultimo aggiornamento: {new Date().getFullYear()}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            {/* Introduction */}
                            <div className="privacy-section mb-5">
                                <div className="section-header d-flex align-items-center mb-4">
                                    <div className="icon-wrapper bg-warning bg-opacity-10 rounded-circle p-3 me-3">
                                        <i className="bi bi-info-circle-fill text-warning fs-4"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-0">Introduzione</h2>
                                </div>
                                <div className="section-content bg-white p-4 rounded-4 shadow-sm">
                                    <p className="text-muted mb-0">
                                        La presente informativa descrive le modalità di gestione del sito FantaWrestling
                                        in riferimento al trattamento dei dati personali degli utenti che lo consultano e utilizzano.
                                        Questa policy è conforme al Regolamento UE 2016/679 (GDPR).
                                    </p>
                                </div>
                            </div>

                            {/* Data Collection */}
                            <div className="privacy-section mb-5">
                                <div className="section-header d-flex align-items-center mb-4">
                                    <div className="icon-wrapper bg-primary bg-opacity-10 rounded-circle p-3 me-3">
                                        <i className="bi bi-database-fill text-primary fs-4"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-0">Tipologie di Dati Raccolti</h2>
                                </div>
                                <div className="section-content bg-white p-4 rounded-4 shadow-sm">
                                    <p className="text-muted mb-4">
                                        FantaWrestling raccoglie alcuni dati personali necessari al funzionamento del servizio:
                                    </p>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="data-type-card p-3 border rounded-3 h-100">
                                                <div className="d-flex align-items-start mb-2">
                                                    <i className="bi bi-person-badge text-primary fs-5 me-2"></i>
                                                    <h6 className="fw-bold text-dark mb-0">Dati di Registrazione</h6>
                                                </div>
                                                <ul className="text-muted small mb-0 ps-3">
                                                    <li>Indirizzo email o account di accesso</li>
                                                    <li>Nome utente</li>
                                                    <li>Credenziali di autenticazione</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="data-type-card p-3 border rounded-3 h-100">
                                                <div className="d-flex align-items-start mb-2">
                                                    <i className="bi bi-graph-up text-success fs-5 me-2"></i>
                                                    <h6 className="fw-bold text-dark mb-0">Dati di Utilizzo</h6>
                                                </div>
                                                <ul className="text-muted small mb-0 ps-3">
                                                    <li>Statistiche di gioco e partecipazione</li>
                                                    <li>Preferenze e configurazioni</li>
                                                    <li>Interazioni con la piattaforma</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="data-type-card p-3 border rounded-3">
                                                <div className="d-flex align-items-start mb-2">
                                                    <i className="bi bi-pc-display text-info fs-5 me-2"></i>
                                                    <h6 className="fw-bold text-dark mb-0">Dati Tecnici</h6>
                                                </div>
                                                <ul className="text-muted small mb-0 ps-3">
                                                    <li>Indirizzo IP e tipo di connessione</li>
                                                    <li>Informazioni sul browser e dispositivo</li>
                                                    <li>Log di sistema e diagnostica</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Processing Methods */}
                            <div className="privacy-section mb-5">
                                <div className="section-header d-flex align-items-center mb-4">
                                    <div className="icon-wrapper bg-success bg-opacity-10 rounded-circle p-3 me-3">
                                        <i className="bi bi-gear-fill text-success fs-4"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-0">Modalità di Trattamento</h2>
                                </div>
                                <div className="section-content bg-white p-4 rounded-4 shadow-sm">
                                    <div className="principles-grid">
                                        <div className="principle-card text-center p-4 border rounded-4">
                                            <i className="bi bi-shield-lock-fill text-success fs-2 mb-3"></i>
                                            <h5 className="fw-bold text-dark mb-2">Sicurezza</h5>
                                            <p className="text-muted small mb-0">
                                                I dati vengono protetti con misure tecniche e organizzative adeguate
                                            </p>
                                        </div>

                                        <div className="principle-card text-center p-4 border rounded-4">
                                            <i className="bi bi-eye-fill text-primary fs-2 mb-3"></i>
                                            <h5 className="fw-bold text-dark mb-2">Trasparenza</h5>
                                            <p className="text-muted small mb-0">
                                                Informazioni chiare su come vengono utilizzati i tuoi dati
                                            </p>
                                        </div>

                                        <div className="principle-card text-center p-4 border rounded-4">
                                            <i className="bi bi-bullseye text-warning fs-2 mb-3"></i>
                                            <h5 className="fw-bold text-dark mb-2">Finalità Limitate</h5>
                                            <p className="text-muted small mb-0">
                                                I dati sono utilizzati solo per gli scopi dichiarati
                                            </p>
                                        </div>
                                    </div>
                                    <p className="text-muted mt-4 mb-0">
                                        I dati vengono trattati in modo lecito, corretto e trasparente, esclusivamente
                                        per fornire il servizio richiesto, migliorare l'esperienza utente e garantire
                                        il corretto funzionamento della piattaforma.
                                    </p>
                                </div>
                            </div>

                            {/* Third Party Services */}
                            <div className="privacy-section mb-5">
                                <div className="section-header d-flex align-items-center mb-4">
                                    <div className="icon-wrapper bg-danger bg-opacity-10 rounded-circle p-3 me-3">
                                        <i className="bi bi-briefcase-fill text-danger fs-4"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-0">Servizi di Terze Parti</h2>
                                </div>
                                <div className="section-content bg-white p-4 rounded-4 shadow-sm">
                                    <p className="text-muted mb-4">
                                        FantaWrestling utilizza i seguenti servizi di terze parti:
                                    </p>

                                    <div className="service-card p-4 border rounded-4 mb-4">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="service-icon bg-danger bg-opacity-10 rounded-circle p-3 me-3">
                                                <i className="bi bi-google text-danger fs-4"></i>
                                            </div>
                                            <div>
                                                <h5 className="fw-bold text-dark mb-1">Firebase (Google LLC)</h5>
                                                <p className="text-muted small mb-0">Per autenticazione, database e hosting</p>
                                            </div>
                                        </div>
                                        <p className="text-muted small mb-0">
                                            Firebase raccoglie dati in forma aggregata o anonima per fornire i servizi
                                            di infrastruttura. Per maggiori informazioni, consulta la
                                            <a href="https://firebase.google.com/support/privacy"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-decoration-none ms-1">
                                                Privacy Policy di Firebase
                                            </a>.
                                        </p>
                                    </div>

                                    <div className="service-card p-4 border rounded-4">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="service-icon bg-primary bg-opacity-10 rounded-circle p-3 me-3">
                                                <i className="bi bi-megaphone-fill text-primary fs-4"></i>
                                            </div>
                                            <div>
                                                <h5 className="fw-bold text-dark mb-1">Google AdSense</h5>
                                                <p className="text-muted small mb-0">Per la visualizzazione di annunci pubblicitari</p>
                                            </div>
                                        </div>
                                        <p className="text-muted small mb-0">
                                            Gli annunci possono essere mostrati in modo contestuale o personalizzato,
                                            in base alle preferenze dell’utente e alle impostazioni del browser.
                                            Per gestire le preferenze pubblicitarie, visita le
                                            <a href="https://adssettings.google.com"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-decoration-none ms-1">
                                                Impostazioni annunci di Google
                                            </a>.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Cookies */}
                            <div className="privacy-section mb-5">
                                <div className="section-header d-flex align-items-center mb-4">
                                    <div className="icon-wrapper bg-info bg-opacity-10 rounded-circle p-3 me-3">
                                        <i className="bi bi-cookie text-info fs-4"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-0">Cookie</h2>
                                </div>
                                <div className="section-content bg-white p-4 rounded-4 shadow-sm">
                                    <div className="alert alert-info border-info bg-info bg-opacity-10 rounded-3">
                                        <div className="d-flex">
                                            <i className="bi bi-info-circle-fill text-info fs-5 me-3"></i>
                                            <div>
                                                <h6 className="fw-bold text-dark mb-2">Gestione dei Cookie</h6>
                                                <p className="text-muted small mb-0">
                                                    Il sito utilizza cookie tecnici e cookie di terze parti per finalità statistiche
                                                    e pubblicitarie. L'utente può gestire o disabilitare i cookie attraverso le
                                                    impostazioni del proprio browser. L’utilizzo dei cookie di terze parti può richiedere il consenso dell’utente,
                                                    che viene richiesto al primo accesso secondo la normativa vigente.

                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-4 g-3">
                                        <div className="col-md-6">
                                            <div className="p-3 border rounded-3">
                                                <h6 className="fw-bold text-dark mb-2">
                                                    <i className="bi bi-hdd-stack text-info me-2"></i>
                                                    Cookie Tecnici
                                                </h6>
                                                <p className="text-muted small mb-0">
                                                    Necessari per il funzionamento del sito e non possono essere disabilitati
                                                </p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="p-3 border rounded-3">
                                                <h6 className="fw-bold text-dark mb-2">
                                                    <i className="bi bi-bar-chart-line text-info me-2"></i>
                                                    Cookie Statistici
                                                </h6>
                                                <p className="text-muted small mb-0">
                                                    Aiutano a comprendere come gli utenti interagiscono con la piattaforma
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* User Rights */}
                            <div className="privacy-section mb-5">
                                <div className="section-header d-flex align-items-center mb-4">
                                    <div className="icon-wrapper bg-warning bg-opacity-10 rounded-circle p-3 me-3">
                                        <i className="bi bi-person-check-fill text-warning fs-4"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-0">Diritti dell'Utente</h2>
                                </div>
                                <div className="section-content bg-white p-4 rounded-4 shadow-sm">
                                    <p className="text-muted mb-4">
                                        Ai sensi del GDPR, hai i seguenti diritti riguardo ai tuoi dati personali:
                                    </p>

                                    <div className="rights-grid">
                                        <div className="right-card p-3 border rounded-3">
                                            <div className="d-flex align-items-center mb-2">
                                                <i className="bi bi-eye-fill text-primary me-2"></i>
                                                <h6 className="fw-bold text-dark mb-0">Diritto di Accesso</h6>
                                            </div>
                                            <p className="text-muted small mb-0">
                                                Ottenere conferma dell'esistenza dei tuoi dati e accedervi
                                            </p>
                                        </div>

                                        <div className="right-card p-3 border rounded-3">
                                            <div className="d-flex align-items-center mb-2">
                                                <i className="bi bi-pencil-square text-success me-2"></i>
                                                <h6 className="fw-bold text-dark mb-0">Diritto di Rettifica</h6>
                                            </div>
                                            <p className="text-muted small mb-0">
                                                Richiedere la correzione di dati inesatti o incompleti
                                            </p>
                                        </div>

                                        <div className="right-card p-3 border rounded-3">
                                            <div className="d-flex align-items-center mb-2">
                                                <i className="bi bi-trash-fill text-danger me-2"></i>
                                                <h6 className="fw-bold text-dark mb-0">Diritto alla Cancellazione</h6>
                                            </div>
                                            <p className="text-muted small mb-0">
                                                Richiedere la cancellazione dei tuoi dati in determinati casi
                                            </p>
                                        </div>

                                        <div className="right-card p-3 border rounded-3">
                                            <div className="d-flex align-items-center mb-2">
                                                <i className="bi bi-file-earmark-text text-info me-2"></i>
                                                <h6 className="fw-bold text-dark mb-0">Diritto alla Portabilità</h6>
                                            </div>
                                            <p className="text-muted small mb-0">
                                                Ricevere i tuoi dati in formato strutturato e interoperabile
                                            </p>
                                        </div>
                                    </div>

                                    <div className="alert alert-warning border-warning bg-warning bg-opacity-10 mt-4 rounded-3">
                                        <div className="d-flex">
                                            <i className="bi bi-clock-history text-warning me-3"></i>
                                            <div>
                                                <p className="text-dark small mb-0">
                                                    Per esercitare questi diritti o per qualsiasi domanda relativa alla privacy,
                                                    contattaci tramite i canali indicati nella piattaforma.
                                                    Ci impegniamo a rispondere entro 30 giorni.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Contact */}
                            <div className="privacy-section">
                                <div className="section-header d-flex align-items-center mb-4">
                                    <div className="icon-wrapper bg-primary bg-opacity-10 rounded-circle p-3 me-3">
                                        <i className="bi bi-envelope-fill text-primary fs-4"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-0">Contatti</h2>
                                </div>
                                <div className="section-content bg-white p-4 rounded-4 shadow-sm">
                                    <div className="contact-info">
                                        <p className="text-muted mb-4">
                                            Per qualsiasi informazione relativa alla presente Privacy Policy o per
                                            esercitare i tuoi diritti, è possibile contattarci tramite:
                                        </p>

                                        <div className="contact-methods">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="contact-icon bg-warning bg-opacity-10 rounded-circle p-2 me-3">
                                                    <i className="bi bi-envelope text-warning"></i>
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold text-dark mb-1">Email</h6>
                                                    <p className="text-muted small mb-0">
                                                        Attraverso il modulo di contatto nella piattaforma
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <div className="contact-icon bg-info bg-opacity-10 rounded-circle p-2 me-3">
                                                    <i className="bi bi-chat-dots text-info"></i>
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold text-dark mb-1">Community</h6>
                                                    <p className="text-muted small mb-0">
                                                        Canale Telegram ufficiale della community
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-5 bg-light">
                <div className="container">
                    <div className="text-center">
                        <h3 className="fw-bold text-dark mb-4">Hai altre domande?</h3>
                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                            <Link to="/about" className="btn btn-outline-dark btn-lg px-4 py-2">
                                <i className="bi bi-info-circle me-2"></i>
                                Chi Siamo
                            </Link>
                            <Link to="/rules" className="btn btn-warning btn-lg px-4 py-2">
                                <i className="bi bi-book me-2"></i>
                                Regolamento
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Privacy;